import { Box, Text, useTheme } from '@primer/react';
import Reveal from './Reveal';

const tools = ['Claude', 'Lovable', 'Cursor', 'Vercel', 'Supabase', 'Figma Make'];

function AIEmbrace() {
  const { colorMode } = useTheme();
  const isDark = colorMode === 'night';

  return (
    <Box
      sx={{
        backgroundColor: isDark ? '#05070a' : '#f0f2f5',
        paddingX: ['24px', '48px', '100px'],
        paddingBottom: [7, 8, 9],
      }}
    >
      <Box sx={{ maxWidth: '1400px', margin: '0 auto', textAlign: 'center' }}>
        <Reveal>
          <Text
            as="p"
            sx={{
              margin: '0 auto',
              marginBottom: 4,
              maxWidth: '700px',
              fontSize: 2,
              lineHeight: 1.7,
              color: isDark ? 'rgba(255, 255, 255, 0.6)' : 'rgba(27, 31, 36, 0.65)',
            }}
          >
            We're not afraid of AI. We embrace it, and use it to its full capacity to move faster
            without cutting corners on craft.
          </Text>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 3 }}>
            {tools.map((tool) => (
              <Box
                key={tool}
                sx={{
                  paddingX: 4,
                  paddingY: 2,
                  borderRadius: '999px',
                  border: isDark ? '1px solid rgba(255, 255, 255, 0.12)' : '1px solid rgba(27, 31, 36, 0.12)',
                  backgroundColor: isDark ? 'rgba(255, 255, 255, 0.03)' : 'rgba(255, 255, 255, 0.7)',
                }}
              >
                <Text sx={{ fontSize: 1, fontWeight: 600, color: isDark ? '#f5f1ea' : '#1b1f24' }}>{tool}</Text>
              </Box>
            ))}
          </Box>
        </Reveal>
      </Box>
    </Box>
  );
}

export default AIEmbrace;
